import { render, staticRenderFns } from "./DeleteItemPopup.vue?vue&type=template&id=7ec55267"
import script from "./DeleteItemPopup.vue?vue&type=script&lang=js"
export * from "./DeleteItemPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports